
/**
 * 미디어 유형
 */
export type GetMediaById200TwoType = typeof GetMediaById200TwoType[keyof typeof GetMediaById200TwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMediaById200TwoType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
  AUDIO: 'AUDIO',
  LINK: 'LINK',
} as const;
